import { AgentDictionaryItem } from '@/models/dictionary/agent';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IAgentDictionaryApi } from '@/types';

export const useAgentDictionary = defineStore('agentDictionary', () => {
    const itemsAll = shallowRef<AgentDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    // actions
    function setData(data: IAgentDictionaryApi[]) {
        console.time('set-agent-dictionary');
        itemsAll.value = data.map((item) => new AgentDictionaryItem(item));
        console.timeEnd('set-agent-dictionary');
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
